export default "__VITE_ASSET__Bngk5qbw__"